import React from 'react';
import InputMask from 'react-input-mask';
import { Col, Label, Input } from 'reactstrap';

export default ({ name, label, placeholder, required, mask, sizeSm, sizeMd, sizeLg, _handleChange, readonly, disabled, value, maxLength}) => {
    sizeSm = !!sizeSm ? sizeSm : 0;
    sizeMd = !!sizeMd ? sizeMd : 0;
    sizeLg = !!sizeLg ? sizeLg : 0;
    if (!!mask) {
        
            return (
                <React.Fragment>
                    <Col sm={sizeSm} md={sizeMd} lg={sizeLg}>
                        <Label>{label}</Label>
                        <InputMask
                            type="text"
                            mask={mask}
                            className="form-control"
                            required={required}
                            placeholder={placeholder}
                            onChange={_handleChange}
                            name={name}
                            value={value}
                            maxLength={maxLength}
                        />
                    </Col>
                </React.Fragment>
            );        
    } else {
        return (
            <React.Fragment>
                <Col sm={sizeSm} md={sizeMd} lg={sizeLg}>
                    <Label>{label}</Label>
                    <Input
                        type="text"
                        className="form-control"
                        required={required}
                        placeholder={placeholder}
                        onChange={_handleChange}
                        name={name}
                        readOnly={readonly}
                        disabled={disabled}
                        value={value}
                        maxLength={maxLength}
                    />
                </Col>
            </React.Fragment>
        );
    }
}